'use client';

import React from 'react';
import Image from 'next/image';
import get from 'lodash/get';
import { BASE_FILE_URL } from '@/common/constants';

const LocalProduct = ({ localProducts }) => {
  const items = get(localProducts, 'results', []);

  if (!items.length) return null;

  return (
    <section className="py-12 bg-white">
      <div className="max-w-screen-xl mx-auto px-4">
        {/* Header */}
        <div className="mb-2 pb-3 border-b-2 border-[#b71c1c] flex justify-between flex-wrap">
          <h2 className="text-[#b71c1c] text-xl font-bold uppercase flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round">
              <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z" />
              <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
            </svg>
            Sản Vật Địa Phương
          </h2>
          <p className="text-gray-500 text-sm mt-1">Tinh hoa nông sản vùng cao Bằng Lang – Tuyên Quang</p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-6">
          {items.map((item) => {
            // const href = websiteCode
            //   ? `/sub/${websiteCode}/${item?.menu?.slug || 'san-vat'}/${item.slug}`
            //   : `/${item?.menu?.slug || 'san-vat'}/${item.slug}`;

            return (
              <div
                key={item.id || item.slug}
                className="group bg-gray-50 border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg hover:-translate-y-1 hover:border-[#b71c1c] transition-all duration-300">
                {/* Image */}
                <div className="relative aspect-[4/3] overflow-hidden">
                  <Image
                    src={`${BASE_FILE_URL}/${item.avatarUrl}`}
                    alt={item.title || item.name || ''}
                    fill
                    className="object-cover group-hover:scale-105 transition-transform duration-400 position-initial"
                    quality={85}
                  />
                  {item.type && (
                    <span className="absolute top-3 right-3 bg-gradient-to-br from-[#f9a825] to-[#f57f17] text-white text-[10px] font-bold uppercase tracking-wide px-2.5 py-1 rounded">
                      {item.type}
                    </span>
                  )}
                </div>

                {/* Info */}
                <div className="p-4">
                  <h4 className="text-[15px] font-bold text-gray-800 group-hover:text-[#b71c1c] transition-colors duration-200 mb-1.5">
                    {item.title || item.name}
                  </h4>
                  {item.desc && <p className="text-[13px] text-gray-500 leading-relaxed line-clamp-2 mb-2.5">{item.desc}</p>}
                  {item.address && (
                    <span className="text-[12px] text-gray-400 flex items-center gap-1.5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="11"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#b71c1c"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round">
                        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                        <circle cx="12" cy="10" r="3" />
                      </svg>
                      {item.address}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        {/* <div className="text-center mt-8">
          <Link
            href={websiteCode ? `/sub/${websiteCode}/san-vat` : '/san-vat'}
            className="inline-flex items-center gap-2.5 bg-[#b71c1c] hover:bg-[#1b5e20] text-white px-8 py-3.5 rounded-full font-bold text-[15px] hover:-translate-y-0.5 transition-all duration-300 shadow-md hover:shadow-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10a4 4 0 0 1-8 0" />
            </svg>
            Xem tất cả sản vật
          </Link>
        </div> */}
      </div>
    </section>
  );
};

export default LocalProduct;
